import React from 'react'
import InputCheckBoxUI from '../../../../widgets/form/InputCheckBoxUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'

const RepaymentModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  ecol, onEcolChange
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Repayments'
    buttonLabel='Initiate'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputCheckBoxUI label='Ecol' 
          onChange={onEcolChange} checked={ecol} 
          name='ecol' 
        />
  </ModalFormUI>

export default RepaymentModalUI
